var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProcessingApplication = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 149,
    viewBox: "0 0 231 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_14910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.175 44.1504H115.48V125.658H184.175V44.1504Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 44.1504H44.6504V125.658H115.48V44.1504Z",
    fill: "#00EC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.193 44.1504H184.175V125.658H184.193V44.1504Z",
    fill: "#00EC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.175 125.658H115.48V126.976H184.175V125.658Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.145 99.6539V70.1537C163.504 70.1537 156.497 63.1485 156.497 54.502H115.479V115.306H156.497C156.497 106.661 163.502 99.6539 172.145 99.6539Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.345 54.5039C72.345 63.1485 65.3398 70.1557 56.6973 70.1557V99.6559C65.3378 99.6559 72.345 106.661 72.345 115.308H115.48V54.5039H72.345Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6503 44.1503H88.8007C88.8027 19.7681 69.0346 0 44.6503 0C20.2661 0 0.5 19.7681 0.5 44.1503C0.5 68.5326 20.2681 88.3007 44.6503 88.3007V44.1503Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.191 125.658H44.6504V148.395H184.191V125.658Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6507 44.1507H78.6051C78.6051 25.3982 63.4032 10.1963 44.6507 10.1963C25.8982 10.1963 10.6982 25.4002 10.6982 44.1507C10.6982 62.9012 25.9002 78.1051 44.6527 78.1051V44.1507H44.6507Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6504 44.1504V88.3007C69.0346 88.3007 88.8007 68.5326 88.8007 44.1504H44.6504Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6288 44.1504H44.6504V78.1288C63.4149 78.1288 78.6288 62.9169 78.6288 44.1504Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.249 125.658H101.594V148.395H127.249V125.658Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6504 133.201H184.191",
    stroke: "#006EF5",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6504 140.854H184.191",
    stroke: "#006EF5",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7285 9.95996V44.4482H68.481",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.048 99.6798V70.1855H115.608V99.6798H196.048Z",
    fill: "#C17C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.255 99.7217V70.1455H172.278V99.7217H184.255Z",
    fill: "#091F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.133 125.938V44.1104L230.5 85.024L184.133 125.938Z",
    fill: "#FFCEC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.438 32.6094L159.5 25.8281V39.5206L170.438 32.6094Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.823 32.6094L170.886 25.8281V39.5206L181.823 32.6094Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_14910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 148.397,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProcessingApplication);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/processingApplication.ae3570631453a24fef316ed496d2c14a.svg";